<template>
  <div class="footer-container">
    <InfoFooter/>
    <div class="footer-bottom">
    </div>
  </div>
</template>
<script>
import PrivacyPolicyDialog from './dialog/PrivacyPolicyDialog.vue';
import InfoFooter from './InfoFooter.vue';

export default {
  components: {
    PrivacyPolicyDialog, InfoFooter
  },
  methods: {
    openPrivacyPolicy() {
      this.$refs.PrivacyPolicyDialog.open('');
    }
  }
}
</script>
<style lang="scss">
.footer-container {
  position: fixed;
  bottom: -5px;
  width: 100%;
  font-size: x-small;
}
.footer-bottom {
  background-color: #d9f0d4;
  padding: 16px 7px 16px 0;
}
</style>
